import { render } from "./plan.vue?vue&type=template&id=01a6d121&scoped=true"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"

import "./plan.vue?vue&type=style&index=0&id=01a6d121&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a6d121"]])

export default __exports__